module.exports = __webpack_public_path__ + "img/web-call-ico.c992b2aa.svg";